import { backgroundColor } from "styled-system";

export const CssSwiper = {
  "&.swiper-tablet .swiper-slide > *:hover , &.swiper-mobile .swiper-slide > *:hover":
    {
      opacity: "1 !important",
    },
  "&.swiper-tablet .swiper-slide-transparent": {
    opacity: "0.5 !important",
  },
  "&.swiper-desktop .swiper-button-prev, .swiper-button-next": {
    color: "#3c3c3b !important",
    zIndex: 0,
  },
  "&.swiper-desktop .swiper-button-next": {
    position: "relative",
    right: "unset !important",
    marginLeft: "30px",
    marginRight: "20px",
  },
  "&.swiper-desktop .swiper-button-prev": {
    position: "relative",
    left: "unset !important",
    marginLeft: "20px",
    marginRight: "30px",
  },
  "&.swiper-desktop .swiper-button-prev::after, &.swiper-desktop .swiper-button-next::after":
    {
      fontSize: "26px !important",
    },
};
